<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterSuccess">
        <feedback-success v-if="isShowableSuccess" :message="successMessage" />
      </transition>
      <transition name="fade" @enter="enterError">
        <feedback-error v-if="isShowableError" :message="errorMessage" />
      </transition>
    </div>
    <div
      v-if="isDisplayableToggleTextLink"
      class="send-other-way-text-link__area"
      @click="toggleShowSendOtherWayArea"
    >
      <p
        class="text-link--bold send-other-way-text-link"
        :class="{
          'tl-chevron-up--bold--right': isShowSendOtherWayArea,
          'tl-chevron-down--bold--right': !isShowSendOtherWayArea
        }"
      >
        {{ textLinkText }}
      </p>
    </div>
    <div
      v-if="!isDisplayableToggleTextLink || isShowSendOtherWayArea"
      class="send-gift-area"
    >
      <div class="buttons-multi url-share-attention__area">
        <div class="btn-multi-block btn-multi-expand-block">
          <div
            class="btn-multi btn-multi-expand--active url-share-attention__header"
          >
            URLのお取り扱いについてのご注意
          </div>
          <div class="btn-multi-expand__contents">
            <div class="btn-multi-expand__explanation">
              <p>ギフトURLは知っていれば誰でもアクセス可能です。</p>
              <p>
                X（旧Twitter）のリプライやLINEのグループトークなど、<strong>第三者がアクセスできる場所に意図せず投稿しないよう</strong>ご注意ください。
              </p>
            </div>
          </div>
        </div>
      </div>
      <p class="gift-url">
        {{ giftUrl }}
      </p>
      <div class="send-gift-main-button-area">
        <button
          class="btn"
          :class="{
            'btn--primary': isCopyButtonPrimary,
            'btn--secondary': !isCopyButtonPrimary
          }"
          @click="onCopy"
        >
          ギフトURLをコピーする
        </button>
      </div>
      <div class="send-gift-other-way__area">
        <p class="send-gift-other-way__title">
          アプリで贈る
        </p>
        <p class="send-gift-other-way__sub">
          ギフトURLは、様々なアプリで送ることができます
        </p>
        <div class="send-gift-other-way__button-area">
          <div class="send-gift-other-way__button-area-row">
            <ButtonSnsSmallWithTitle title="LINE">
              <ButtonSnsSmallLine @click-line-button="onClickLineButton" />
            </ButtonSnsSmallWithTitle>
            <ButtonSnsSmallWithTitle title="X">
              <ButtonSnsSmallX @click-x-button="onClickXButton" />
            </ButtonSnsSmallWithTitle>
            <ButtonSnsSmallWithTitle title="Messenger">
              <ButtonSnsSmallMessenger
                @click-messenger-button="onClickMessengerButton"
              />
            </ButtonSnsSmallWithTitle>
          </div>
          <div class="send-gift-other-way__button-area-row">
            <ButtonSnsSmallWithTitle title="Instagram">
              <ButtonSnsSmallInstagram
                @click-instagram-button="onClickInstagramButton"
              />
            </ButtonSnsSmallWithTitle>
            <ButtonSnsSmallWithTitle title="Mail">
              <ButtonSnsSmallEmail @click-email-button="onClickMailButton" />
            </ButtonSnsSmallWithTitle>
            <ButtonSnsSmallWithTitle v-if="canShare" title="他のアプリ">
              <ButtonSnsSmallOthers
                @click-others-button="onClickOthersButton"
              />
            </ButtonSnsSmallWithTitle>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../atoms/feedbacks/feedback-error.vue'
import ButtonSnsSmallWithTitle from '../../molecules/buttons/sns/ButtonSnsSmallWithTitle.vue'
import ButtonSnsSmallLine from '../../molecules/buttons/sns/ButtonSnsSmallLine.vue'
import ButtonSnsSmallX from '../../molecules/buttons/sns/ButtonSnsSmallX.vue'
import ButtonSnsSmallMessenger from '../../molecules/buttons/sns/ButtonSnsSmallMessenger.vue'
import ButtonSnsSmallInstagram from '../../molecules/buttons/sns/ButtonSnsSmallInstagram.vue'
import ButtonSnsSmallEmail from '../../molecules/buttons/sns/ButtonSnsSmallEmail.vue'
import ButtonSnsSmallOthers from '../../molecules/buttons/sns/ButtonSnsSmallOthers.vue'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    ButtonSnsSmallWithTitle,
    ButtonSnsSmallLine,
    ButtonSnsSmallX,
    ButtonSnsSmallMessenger,
    ButtonSnsSmallInstagram,
    ButtonSnsSmallEmail,
    ButtonSnsSmallOthers
  },
  props: {
    giftUrl: {
      type: String,
      required: true
    },
    isDisplayableToggleTextLink: {
      type: Boolean,
      required: true
    },
    isCopyButtonPrimary: {
      type: Boolean,
      required: true
    },
    textLinkText: {
      type: String,
      required: false,
      default: 'メール以外の方法でもギフトURLを送る'
    }
  },
  data() {
    return {
      isShowableSuccess: false,
      successMessage: '',
      isShowableError: false,
      errorMessage: '',
      isShowSendOtherWayArea: false
    }
  },
  computed: {
    canShare() {
      return navigator.canShare
    }
  },
  methods: {
    pushGiftSendingToDataLayer(sentVia) {
      dataLayer.push({
        event: 'gift_sending',
        sent_via: sentVia
      })
    },
    onCopy() {
      this.pushGiftSendingToDataLayer('copy')
      const result = navigator.clipboard.writeText(this.giftUrl)
      if (result) {
        this.successMessage = 'ギフトURLをコピーしました'
        this.isShowableSuccess = true
      }
      event.preventDefault()
    },
    enterSuccess() {
      setTimeout(() => {
        this.isShowableSuccess = false
      }, 3000)
    },
    enterError() {
      setTimeout(() => {
        this.isShowableError = false
      }, 3000)
    },
    onClickLineButton() {
      this.pushGiftSendingToDataLayer('line')
      const url = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        this.giftUrl
      )}`
      this.openUrlInNewPage(url)
    },
    onClickXButton() {
      this.pushGiftSendingToDataLayer('x')
      this.openUrlInNewPage('https://twitter.com/messages')
    },
    onClickMessengerButton() {
      this.pushGiftSendingToDataLayer('messenger')
      this.openUrlInNewPage('https://www.facebook.com/messages/new')
    },
    onClickInstagramButton() {
      this.pushGiftSendingToDataLayer('instagram')
      this.openUrlInNewPage('https://www.instagram.com/direct/new/')
    },
    onClickOthersButton() {
      this.pushGiftSendingToDataLayer('others')
      navigator.share({
        url: this.giftUrl
      })
    },
    openUrlInNewPage(url) {
      window.open(url, '_blank')
    },
    onClickMailButton() {
      this.pushGiftSendingToDataLayer('mail')
      // mailtoはwindow.openで開くとtoが更新されないなどの事象が発生するのでwindow.location.hrefを使用する
      window.location.href = `mailto:?subject=[giftee]ギフトを贈ります！&body=${encodeURIComponent(
        this.giftUrl
      )}`
    },
    onClickBackToTop() {
      window.location.href = '/'
    },
    onClickBackWishList(path) {
      window.location.href = path
    },
    toggleShowSendOtherWayArea() {
      this.isShowSendOtherWayArea = !this.isShowSendOtherWayArea
    }
  }
}
</script>
<style lang="scss" scoped>
.url-share-attention {
  &__area {
    max-width: 343px;
    margin: 0 auto 32px auto;
  }

  &__header {
    text-align: center;
    font-weight: bold;
    line-height: 1.6;
    color: $danger;
    cursor: default;

    &:hover {
      opacity: 1;
    }
  }
}
.send-other-way-text-link {
  display: inline-block;
  margin-bottom: 24px;
  @media screen and (max-width: $small-contents-width) {
    margin-bottom: 6.13vw;
  }
}

.send-gift-area {
  .gift-url {
    overflow-wrap: break-word;
    @extend %caption;
    margin-bottom: 8px;
    padding: 0 16px;

    @media screen and (max-width: $small-contents-width) {
      margin-bottom: 2.13vw;
      padding-left: 4.27vw;
      padding-right: 4.27vw;
    }
  }

  .send-gift-main-button-area {
    max-width: 343px;
    margin-bottom: 40px;
    padding: 0 16px;

    @media screen and (max-width: $small-contents-width) {
      margin-bottom: 10.67vw;
      padding-left: 4.27vw;
      padding-right: 4.27vw;
    }
  }

  .send-gift-other-way {
    &__area {
      margin-bottom: 40px;

      @media screen and (max-width: $small-contents-width) {
        margin-bottom: 10.67vw;
      }
    }

    &__title {
      @extend %body-bold;
      margin-bottom: 16px;

      @media screen and (max-width: $small-contents-width) {
        margin-bottom: 4.27vw;
      }
    }

    &__sub {
      font-style: normal;
      font-weight: normal;
      font-size: 1.2rem;
      line-height: 100%;
      color: $gray-1;
      padding: 0 12px;
      @media screen and (max-width: $small-contents-width) {
        // 12px(基準のpadding or margin)/375px(基準の親要素のwidth)*100 = 3.2
        padding-left: 3.2vw;
        padding-right: 3.2vw;
      }
    }

    &__button-area {
      margin-top: 40px;
      display: flex;
      gap: 24px;
      justify-content: center;
      max-width: 343px;
      padding: 0 16px;

      @media screen and (max-width: $small-contents-width) {
        margin-top: 10.67vw;
        padding-left: 4.27vw;
        padding-right: 4.27vw;
      }

      @media screen and (max-width: ($base-contents-width - 1)) {
        display: grid;
        gap: 16px;
      }
    }

    &__button-area-row {
      display: flex;
      gap: 24px;
      justify-content: center;

      button {
        @media screen and (max-width: ($base-contents-width - 1)) {
          width: 56px;
          height: 56px;
        }
      }
    }
  }
}
</style>
